// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"919ce18e","648":"f7a74b74"}[chunkId] + ".chunk.js";
};